import { useCallback, useState } from 'react';

const FIELD_CHANGE_DELAY = 100;

type UseOnFieldChangeReturnType = (
  field: string,
  value: string,
  isValid: boolean,
) => void;

const useOnFieldChange = (
  action: (value: string, isValid: boolean) => void,
): UseOnFieldChangeReturnType => {
  const [fieldChangeTimeout, setFieldChangeTimeout] = useState<NodeJS.Timeout | null>(null);

  return useCallback(
    (field: string, value: string, isValid: boolean): void => {
      if (fieldChangeTimeout) {
        clearTimeout(fieldChangeTimeout);
      }

      const timeoutId = setTimeout(
        () => action(value, isValid),
        FIELD_CHANGE_DELAY,
      );

      setFieldChangeTimeout(timeoutId);
    },
    [
      action,
      fieldChangeTimeout,
      setFieldChangeTimeout,
    ],
  );
};

export type { UseOnFieldChangeReturnType };
export { useOnFieldChange };
